"use strict";

require('./CompanyUserRoleService.js');
var LIMIT = 20;
CompanyUserRoleListCtrl.$inject = [
'$scope',
'$state',
'$q',
'growl',
'$modal',
'$translate',
'$stateParams',
'CompanyUserRoleService',
'userRoles',
];

function CompanyUserRoleListCtrl(
$scope,
$state,
$q,
growl,
$modal,
$translate,
$stateParams,
CompanyUserRoleService,
userRoles) {

  $scope.userRoles = userRoles;
  $scope.page = $stateParams.page | 0;
  if ($scope.userRoles.length > LIMIT) {
    $scope.more = true;
    $scope.userRoles.pop();
  }

  var memberPromises = [];
  angular.forEach($scope.userRoles, function(v){
    memberPromises.push(CompanyUserRoleService.queryUsers({
      companyId: $stateParams.companyId,
      roleId: v.id
    }).$promise);
  });

  $q.all(memberPromises).then(function(m){
    angular.forEach(m, function(v, k){
      $scope.userRoles[k].members = angular.copy(v);
    });
  });

  $scope.showModalDeleteUserRole = function(userRole, index) {
    var angularModal = $modal({
      scope: $scope,
      prefixEvent: "modalTextBox",
      controller: [
        "$scope",
        function($scope) {
          $scope.confirmName = $translate.instant("user-role.confirm-delete-dashboard");
          $scope.activeDelete = function() {
            $scope.remove(userRole, index);
          };
        },
      ],
      templateUrl:
        "partials/company/publications/detail/latest/confirm-delete.html",
      show: true,
    });
  };

  $scope.remove = function(role, index) {
    CompanyUserRoleService.delete({
      companyId: $stateParams.companyId,
      roleId: role.id
    }, function(){
      $scope.userRoles.splice(index, 1);
    });
  };

  $scope.copyUserRole = function(role) {
    CompanyUserRoleService.copyUserRole({
      companyId: $stateParams.companyId,
      roleId: role.id
    }, {}, function(){
      growl.addSuccessMessage($translate.instant("user-role.copy-success"));
      $state.reload();
    }, function() {
      growl.addErrorMessage($translate.instant("user-role.copy-failure"));
    });
  };
}

CompanyUserRoleListCtrl.resolve = {
  userRoles: ['CompanyUserRoleService', '$stateParams', function(userRoleService, $stateParams) {
    return userRoleService.query({companyId: $stateParams.companyId, limit: LIMIT + 1, offset: ($stateParams.page|0) * LIMIT}).$promise;
  }]
};

module.exports = CompanyUserRoleListCtrl;

angular.module('dokiv')
  .controller('CompanyUserRoleListCtrl', CompanyUserRoleListCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/CompanyUserRoleListCtrl.js
// module id = 427
// module chunks = 0